define('score_bootstrap/Models/Comments/CommentsResult',[], function () {
    "use strict";

    function CommentsResult(comments, pageNumber, totalComments, totalPages, rootId, resultStatus, userTimeOffset) {

        function intOrNull(value) {
            value = parseInt(value, 10);
            return isNaN(value) ? null : value;
        }

        Object.defineProperties(this,
            {
                comments: {
                    enumerable: true,
                    value: comments || []
                },
                pageNumber: {
                    enumerable: true,
                    value: intOrNull(pageNumber)
                },
                totalComments: {
                    enumerable: true,
                    value: intOrNull(totalComments)
                },
                totalPages: {
                    enumerable: true,
                    value: intOrNull(totalPages)
                },
                rootId: {
                    enumerable: true,
                    value: intOrNull(rootId)
                },
                resultStatus: {
                    enumerable: false,
                    value: resultStatus
                },
                userTimeOffset:  {
                    enumerable: false,
                    value: userTimeOffset
                }
            });
    }

    return CommentsResult;
});
